import { NgModule } from "@angular/core";
import { SelectCountryComponent } from "./select-country.component";

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { CommonModule } from "@angular/common";

@NgModule({
    declarations: [
        SelectCountryComponent
    ],
    imports: [
        CommonModule,
        FGBSharedModule
    ],
    exports: [
        SelectCountryComponent
    ]
})
export class SelectCountryModule{}